var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "test-badge-wrapper" }, [
      _c("span", { staticClass: "test-badge text-body-3-medium" }, [
        _vm._v("TEST"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }